import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
  providedIn: 'root'
})

export class UrlEndpoint extends EndpointFactory {

  private readonly _baseUrl: string = "/api/Url/";

  get baseUrl() { return this.configurations.baseUrl + this._baseUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService,
    errorHandleService: ErrorHandleService, injector: Injector) {

    super(http, configurations, errorHandleService, injector);
  }

  getSaikiTubeUrlEndpoint<T>(): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetSaikiTubeUrl/`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getSaikiTubeUrlEndpoint());
      }));
  }

  updateSaikiTubeUrlEndpoint<T>(url: string): Observable<T> {
    let endpointUrl = `${this.baseUrl}UpdateSaikiTubeUrl/`;

    // " "で囲んでいないとAPI側で値を受け取れない為
    let body = `"${url}"`;

    return this.http.post<T>(endpointUrl, body, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.updateSaikiTubeUrlEndpoint(url));
      }));
  }
}
